import { render, staticRenderFns } from "./leftCol_Mobile.vue?vue&type=template&id=413d2db0"
import script from "./leftCol_Mobile.vue?vue&type=script&lang=js"
export * from "./leftCol_Mobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports